import MapScanCount from './map-scan-count.container';

export default MapScanCount;
